import meteringCrudFactory from "../meteringCrudFactory";
import type { MeteringProduct, MeteringProductTemplateResponse } from "@/features/metering/types";
import { logError, logEvent, logMeasurement } from "@/loggers";
import { FEATURE_NAMES, METRIC_TYPE } from "@/loggers/types";

const PRODUCT_TEMPLATE_PATH = "product-template";
const api = meteringCrudFactory(PRODUCT_TEMPLATE_PATH);

const serializeProductCodes = (params: Record<string, MeteringProduct[]>): string => {
  const searchParams = new URLSearchParams();
  params.productCodes?.forEach((productCode) => searchParams.append("productCodes", productCode));
  return searchParams.toString();
};

export const fetchMeteringProductTemplate = async (
  productCodes?: MeteringProduct[]
): Promise<MeteringProductTemplateResponse> => {
  const apiStart = performance.now();
  const params: Record<string, MeteringProduct[]> = {};
  if (productCodes?.length) params.productCodes = productCodes;

  try {
    return await api.getAll<MeteringProductTemplateResponse>({ params, paramsSerializer: serializeProductCodes });
  } catch (err) {
    logEvent(FEATURE_NAMES.MVS_METERING, METRIC_TYPE.API_CALL_FAILURE, {
      api: PRODUCT_TEMPLATE_PATH,
      statusCode: err?.response?.status,
      error: err instanceof Error ? err.message : String(err),
      params: JSON.stringify(productCodes)
    });
    logError(
      FEATURE_NAMES.MVS_METERING,
      `Error fetching product template: ${err instanceof Error ? err.message : String(err)}`
    );
    throw err;
  } finally {
    logMeasurement(FEATURE_NAMES.MVS_METERING, METRIC_TYPE.API_CALL_LATENCY, performance.now() - apiStart, {
      api: PRODUCT_TEMPLATE_PATH,
      params: JSON.stringify(productCodes)
    });
  }
};
